<template>
  <b-container>
    <b-card class="panel">
    <Loading :active.sync="Loading"></Loading>
    <div class="controles">
      <h2>Reporte por turno</h2>
    </div>
    <div>
       
      <b-form-select class="select-tiempo" v-model="tiempo" :options="options"></b-form-select>
      <div>
            <label for="datepicker-sm">Seleccione el día</label>
            <Vbdatapicker v-model="dia"  />
      </div>
      
      <b-button class="generar"  @click="generar()">Generar</b-button>
    </div>   
   
      
    </b-card> 
    <b-card class="panel" v-if="arrData.length > 0">
       <!--
        <b-table
            :items="arrData" 
            :fields="fields"
        >
            
        </b-table>
        -->
        
            <div v-for="(item, index) in arrData2" :key="index">
              <div v-for="(column, indexColumn) in maquina" :key="indexColumn">
                  <h2>{{ nombreMaquina(column) }}</h2>
                  <b-table :items="item[column]" :fields="fields"  outlined></b-table>
              </div>
            </div>
          
        

    </b-card> 
    <b-card class="panel"  v-else>
        <h2>Sin datos.</h2>
    </b-card> 
  </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters} from 'vuex'
    import _ from 'lodash'
    
    import Vbdatapicker from '@/components/partials/vbdatapicker'
    import VbdatapickerWeek from '@/components/partials/vbdatapickerWeek'
    import VbdatapickerMonth from '@/components/partials/vbdatapickerMonth'
    import VbdatapickerYear from '@/components/partials/vbdatapickerYear'
    import moment from 'moment'
     import customMixin from '@/mixins/customMixin'
    export default {
        name:'Turno',
         mixins : [customMixin],
        components:{
            Loading,Vbdatapicker, VbdatapickerWeek, VbdatapickerMonth, VbdatapickerYear
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('turno',['reporte']),

            
        },
        data:function () {
            return{
                maquina:[],
                tiempo: null,
                orden: null,
                options:[
                    {value: null, text: 'Seleccione el turno'},
                    {value: 1, text: 'Diurno'},
                    {value: 2, text: 'Nocturno'},
                    
                    ],
                dia:null,
                arrData:[],
                arrData2:[],
                fields:[
                    { key: 'Operador', label: 'Operador'},
                    { key: 'Orden', label: 'orden'},
                    { key: 'Contador', label: 'Totales'},
                    
                    ]
            }            
        },
        methods:{
            ...mapActions({
                
                _fetchDiurno: 'turno/reporteDiurno',
                _fetchNocturno: 'turno/reporteNocturno',
            }),
            init(){
                
               
            },//init
            generar(){
                if(this.tiempo === 1){
                    this.diurno()
                }
                if(this.tiempo === 2){
                    this.nocturno()
                }
            },
            diurno(){
                let payload = {
                    'dia' : this.dia
                }
                this.arrData = []//se limpia
                this.arrData2 = []//se limpia
                let that  = this
                this._fetchDiurno(payload).then(()=>{
                    _.forEach(this.reporte, function(value,key){
                        let fecha =  that.depurarFecha(value)
                        
                        if(fecha >= that.dia.concat(' 08:00')  && fecha <= that.dia.concat(' 19:59')) {
                            if(that.arrData.length === 0){
                                that.cargarArray(value, fecha)
                            } else {
                                let sw = true
                                _.forEach(that.arrData, function(vvalue,kkey){
                                   if(value.Orden == vvalue.Orden && value.Operador == vvalue.Operador && value.Origen == vvalue.Origen ){
                                        if ( Number(value.Contador) > Number(vvalue.Contador) ){
                                            that.reemplazarArray(value,vvalue,fecha)   
                                        }
                                        sw = false
                                   } 
                                })
                                if(sw){
                                        that.cargarArray(value, fecha)    
                                }
                            }
                        }
                        
                    })
                    this.formatearTabla()
                    
                })
            },
            nocturno(){
                let payload = {
                    'dia' : this.dia
                }
                this.arrData = []//se limpia
                this.arrData2 = []//se limpia
                let that  = this
                this._fetchNocturno(payload).then(()=>{
                    _.forEach(this.reporte, function(value,key){
                        let dia2 = new Date()
                        let fecha =  that.depurarFecha(value)
                        dia2 = that.addDays(moment(that.dia), 1)
                        dia2 =  moment(dia2).format('YYYY-MM-DD')
                        if(fecha >= that.dia.concat(' 20:00')  && fecha <= dia2.concat(' 07:59')) {          
                            if(that.arrData.length === 0){
                                that.cargarArray(value, fecha)
                            } else {
                                let sw = true
                                _.forEach(that.arrData, function(vvalue,kkey){
                                   if(value.Orden == vvalue.Orden && value.Operador == vvalue.Operador && value.Origen == vvalue.Origen ){
                                        if ( Number(value.Contador) > Number(vvalue.Contador) ){
                                            that.reemplazarArray(value,vvalue,fecha)   
                                        }
                                        sw = false
                                   } 
                                })
                                if(sw){
                                        that.cargarArray(value, fecha)    
                                }
                            }
                        }
                    })
                    this.formatearTabla()
                })
            },
            formatearTabla(){
                let result = _.uniqBy(this.arrData,'Origen'); //se eliminan duplicados
                let that = this 
                this.maquina  = []//se limpia
                _.forEach(result, function(value,key){
                        that.maquina.push(value.Origen) //se llena el vector con las maquinas
                })
                //se agrupa con respecto a las maquinas
                this.arrData2.push(  _.groupBy(this.arrData, function(value) {  
                    return value.Origen
                    })
                )
            },   
            cargarArray(value, fecha){
                let payload = {
                    DiaHora: fecha,
                    Orden : value.Orden,
                    Operador: value.Operador,
                    Origen: value.Origen,
                    Contador: value.Contador
                }
                this.arrData.push(payload)
            },      
            reemplazarArray(value1, value2, fecha){
                value2.DiaHora  = fecha
                value2.Orden    = value1.Orden
                value2.Operador = value1.Operador
                value2.Origen   = value1.Origen
                value2.Contador = value1.Contador
            },
            depurarFecha(value){
                let var1 = value.DiaHora.replace(/\. /g, '') // para borrar un punto con espacio en am. pm.
                let var2 = var1.replace(/\./g, '') // para borrar los puntos . y poder hacer la comparacion!!!
                return moment(var2,'DD/MM/YYYY HH:mm:a').format('YYYY-MM-DD HH:mm')  // ahora si podemos trabajar con fechas como Jesus manda
            },
            addDays(date, days) {
                let result = new Date(date)
                result.setDate(result.getDate() + days)
                return result
            }
        }
        
    }
</script>

<style lang="scss" scoped>
.controles{
    display:flex;
    margin-top:1em;
    align-items: center;
}
h2{
    align-self:center;
    font-size: 1.5em;
    margin-bottom:0.5em;
}

.panel{
      margin-top:1em;
    }
.generar {
    margin-top:0.5em;
}
.select-operador{
    margin-top:0.5em;
}
.select-tiempo{
    margin-top:0.5em;
}
@media screen and (max-width: 576px) {
    .controles{
        flex-direction: column;
        padding:0;
        margin:0;
        
    }
    
}
</style>